// extracted by mini-css-extract-plugin
export default {"message-close":"message_message-close__sUTPu","message-open":"message_message-open__bmizw","error-text":"message_error-text__3IW4B","success-text":"message_success-text__NtfBt"};